const translations = {
    title: 'Polityka prywatności',
    description: '',
    canonical: 'string',
    image: '',
    robots: 'noindex, nofollow',
};

export default translations;